import React, { useEffect, useRef, useState } from "react";
import { EFFECTS, effects, setEffect } from "./render/effects";

// The cog beside the renderer toggle, bottom-right. Opens a short list of the
// optional visual effects.
//
// Same footprint and colouring as the renderer toggle it sits next to, so the two
// read as one strip rather than two unrelated controls.

const styles = {
  // Parked clear of the renderer toggle, which sits at right: 0 and is the widest
  // thing on this strip.
  wrap: {
    position: "absolute",
    right: "118px",
    bottom: 0,
    zIndex: 1000,
  },
  button: {
    display: "block",
    padding: "4px 8px",
    border: "none",
    borderTopLeftRadius: "6px",
    background: "rgba(0, 0, 0, 0.55)",
    color: "#eee",
    font: "11px/1.45 Consolas, monospace",
    cursor: "pointer",
  },
  panel: {
    position: "absolute",
    right: 0,
    bottom: "24px",
    minWidth: "190px",
    padding: "6px 8px",
    borderRadius: "6px",
    background: "rgba(0, 0, 0, 0.78)",
    color: "#eee",
    font: "11px/1.6 Consolas, monospace",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

const EffectsMenu = () => {
  const [open, setOpen] = useState(false);
  // The flags live outside React, so the menu keeps its own copy purely to
  // re-render the ticks.
  const [, bump] = useState(0);
  const wrapRef = useRef(null);

  // Clicking the map should close it, but clicking inside should not.
  useEffect(() => {
    if (!open) return undefined;
    const onDown = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", onDown);
    return () => document.removeEventListener("mousedown", onDown);
  }, [open]);

  const toggle = (key) => {
    setEffect(key, !effects[key]);
    bump((n) => n + 1);
  };

  return (
    <div ref={wrapRef} style={styles.wrap}>
      {open && (
        <div style={styles.panel}>
          {EFFECTS.map(({ key, label, hint }) => (
            <label key={key} style={styles.row} title={hint}>
              <input
                type="checkbox"
                checked={!!effects[key]}
                onChange={() => toggle(key)}
              />
              {label}
            </label>
          ))}
        </div>
      )}
      <button
        type="button"
        style={styles.button}
        title="Visual effects"
        onClick={() => setOpen(!open)}
      >
        ⚙
      </button>
    </div>
  );
};

export default EffectsMenu;
